// src/components/ui/emphasis.jsx — `<b>…</b>` in OUR copy → <strong>, for the dialogs that show our sentences
// (OutcomeDialog, BillingConfirmDialog). v204.
//
// ⛔ Built as React elements, never parsed as HTML: any other markup in the string stays literal text, so an
// interpolated value (a plan name) can never inject anything. Only flat `<b>text</b>` spans are recognised.
import React from 'react';

/** The string with its `<b>…</b>` spans as <strong> elements; a string without them (or a non-string) as is. */
export function withEmphasis(text) {
  if (typeof text !== 'string' || !text.includes('<b>')) return text;
  return text.split(/(<b>[^<]*<\/b>)/).map((part, i) => {
    const bold = /^<b>([^<]*)<\/b>$/.exec(part);
    // eslint-disable-next-line react/no-array-index-key
    return bold ? <strong key={i}>{bold[1]}</strong> : part;
  });
}
